import React from 'react';
import Text from './Text';

const NotFound = () => (
  <Text text="😳 Whoops! This is not the page you were looking for. Please click a button in the navbar to find your way back." />
);

export default NotFound;
